import { render } from "./gimbalControl.vue?vue&type=template&id=2427b589&scoped=true"
import script from "./gimbalControl.vue?vue&type=script&lang=js"
export * from "./gimbalControl.vue?vue&type=script&lang=js"

import "./gimbalControl.vue?vue&type=style&index=0&id=2427b589&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2427b589"]])

export default __exports__